import React from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { getOrgTermsContent } from '../../../content/utils.js';

const ProjectsFilter = ({
  projects,
  relatedProjects,
  project,
  onProjectChange,
}) => {
  const { name } = projects.find((item) => item.id === project.id) || '';

  const handleSelect = (relatedProject) => onProjectChange(relatedProject);

  const renderMenuItem = (relatedProject) => {
    const { name } =
      projects.find((project) => project.id === relatedProject.project_id) ||
      '';
    return (
      <MenuItem
        key={relatedProject.project_id}
        eventKey={relatedProject}
        onSelect={handleSelect}
      >
        {name}
      </MenuItem>
    );
  };

  return (
    <div className="flex flex-align-center report-filters p-0">
      <div className="text-muted m-r-16">
        Selected {getOrgTermsContent('project')}
      </div>
      <div className="report-filter m-0" style={{ minWidth: '230px' }}>
        <ButtonToolbar>
          <DropdownButton
            bsStyle="info"
            id="projects-select"
            className="btn-block"
            title={<span style={{ paddingRight: '12px' }}>{name}</span>}
            onSelect={handleSelect}
          >
            {relatedProjects.map(renderMenuItem)}
          </DropdownButton>
        </ButtonToolbar>
      </div>
    </div>
  );
};

export default ProjectsFilter;
